// Exotic clownfish (Nemos) currently being bred in-house. Real owner stock photos.
export const CLOWNFISH_IS_SAMPLE = false;

export const CLOWNFISH = [
  {
    name: "Picasso Percula",
    tag: "Designer Percula",
    img: "/corals/nemo-picasso.jpg",
    desc: "Bold, irregular white bars edged in thick black — no two Picassos are ever patterned alike.",
  },
  {
    name: "Black Storm",
    tag: "Premium Designer",
    img: "/corals/nemo-black-storm.jpg",
    desc: "Striking black-and-white storm patterning — a true showstopper.",
  },
  {
    name: "Frostbite",
    tag: "Premium Designer",
    img: "/corals/nemo-frostbite.jpg",
    desc: "Frosty white body with bold dark markings and rich red-orange accents.",
  },
  {
    name: "Orange Ocellaris (Nemo)",
    tag: "Classic Clownfish",
    img: "/corals/nemo-orange.jpg",
    desc: "The classic — bright orange with three clean white bars. Hardy, reef-safe and the perfect first clownfish.",
  },
];
